/**
 * Os passos de apresentação — o registro, em UM lugar (card 1849823264159827694).
 *
 * ═══ Onde cada peça precisa ser conhecida, e o que acontece se faltar ══════════════════════
 *
 * | Onde | Pergunta que responde | Se faltar |
 * |---|---|---|
 * | `view.ts` → `context.register` | as extensões existem no editor? | a ação não aparece, o controlador nunca escuta a tecla, o badge nunca desenha |
 * | `effects.ts` → `customElements.define` | o navegador conhece a tag? | o elemento é criado no DOM e fica **0×0, sem shadowRoot, sem um erro sequer** |

 * ⚠️ **O botão deixou de ser componente nosso** no 1º ciclo de campo: a lista agora é slot de
 * um `editor-menu-button` do upstream, que é o idioma desta barra e o único que renderiza na
 * *top layer* do navegador. Sobrou **uma** tag para definir.
 *
 * ⚠️ A segunda linha é a **Regra 8.52**, e ela custou um bloco inteiro que nunca renderizou em
 * ambiente nenhum: os três pontos de registro estavam corretos, o teste os conferia por
 * `import`, e o `customElements.define` não tinha chamador. **Importar não é definir.** Por
 * isso as duas metades saem daqui, e o teste pergunta o que o registro FAZ acontecer.
 *
 * ═══ O que este arquivo NÃO faz ════════════════════════════════════════════════════════════
 *
 * Não registra ação de toolbar por conta própria em `affine:surface:*` do upstream: as duas
 * ações usam o slot `custom:` (ver `acao-de-marcar.ts`), que é aditivo por desenho. Os únicos
 * arquivos do upstream que este card edita são os quatro declarados em
 * `infra/affine/UPSTREAM`, e dois deles são estas duas linhas de fiação.
 */

import type { ExtensionType } from '@blocksuite/store';

import { acaoDeMarcarPasso } from './acao-de-marcar';
import { acaoDeOrdemDosPassos } from './acao-de-ordem';
import { BadgeDePassosOverlay } from './badge';
import { ControladorDePassos } from './controlador';
import { TAG_DO_MENU_DE_PASSOS, TuninhoMenuDePassos } from './menu-de-passos';

export * from './badge';
export * from './controlador';
export * from './marcacao';
export * from './passos';
export * from './rotulo';

/** Tudo que o editor de edgeless precisa registrar para os passos funcionarem. */
export const extensoesDosPassos: ExtensionType[] = [
  ControladorDePassos,
  BadgeDePassosOverlay,
  acaoDeMarcarPasso,
  acaoDeOrdemDosPassos,
];

/**
 * Define as tags no navegador.
 *
 * O guarda por `customElements.get` existe porque `effects()` pode rodar mais de uma vez numa
 * sessão (dois editores abertos), e `define` da mesma tag duas vezes **lança**.
 */
export function registrarElementosDosPassos() {
  if (typeof customElements === 'undefined') return;
  if (!customElements.get(TAG_DO_MENU_DE_PASSOS)) {
    customElements.define(TAG_DO_MENU_DE_PASSOS, TuninhoMenuDePassos);
  }
}
